export const isValidHexColor = (hex: string) => /^#[0-9A-F]{6}$/i.test(hex)
